






















import {Component, Vue, Watch} from "vue-property-decorator";
import {StockInParams} from "@/modules/warehouses/params";
import debounce from "lodash/debounce";
import {WarehouseStore} from "@/modules/warehouses/store";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {PartnerType, StockInTargetType} from "@/enums/type";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";

@Component({
  name: "StockInSearch",
  components: {PartnerSelector, EmployeeSelector}
})
export default class extends Vue {
  params = new StockInParams();
  StockInTargetType = StockInTargetType;
  PartnerType = PartnerType;
  targetType = StockInTargetType.Employee;

  @Watch("params", {deep: true, immediate: false})
  onFormChange(val: any) {
    this.handleChange(val);
  }

  onchangeTargetType() {
    if (this.params.acceptanceTargetRowGuid)
      this.params.acceptanceTargetRowGuid = undefined;
  }

  handleChange = debounce(function (val) {
    WarehouseStore.updateStockInParams(val);
    WarehouseStore.allBillLadingNeedStockIn(val)
  }, 500);
}
